import angular from 'angular';

import { FlatRatesConfirmationComponent } from './flat-rates-confirmation/flat-rates-confirmation.component';
import { FlatRatesModal } from './flat-rates-modal/flat-rates-modal.service';

angular
  .module('app.create-shipments.flat-rates-modal', [])
  .component('flatRatesConfirmation', FlatRatesConfirmationComponent)
  .service('FlatRatesModal', FlatRatesModal);
